import { Injectable } from '@angular/core';

import { EarlyPayoutSubscriptionSource } from '../models/early-payout-subscription-source';
import { EarlyPayoutSubmitService } from './early-payout-submit.service';
import { EarlyPayoutSubscriptionService } from './early-payout-subscription.service';
import { EarlyPayoutService } from './early-payout.service';

@Injectable({ providedIn: 'root' })
export class EarlyPayoutMyBetsService extends EarlyPayoutService {
    constructor() {
        super(EarlyPayoutSubscriptionSource.MyBets);
    }
}

@Injectable({ providedIn: 'root' })
export class EarlyPayoutEditBetService extends EarlyPayoutService {
    constructor() {
        super(EarlyPayoutSubscriptionSource.EditBet);
    }
}

@Injectable({ providedIn: 'root' })
export class EarlyPayoutSubscriptionMyBetsService extends EarlyPayoutSubscriptionService {
    constructor(earlyPayoutService: EarlyPayoutMyBetsService) {
        super(earlyPayoutService);
    }
}

@Injectable({ providedIn: 'root' })
export class EarlyPayoutSubscriptionEditBetService extends EarlyPayoutSubscriptionService {
    constructor(earlyPayoutService: EarlyPayoutEditBetService) {
        super(earlyPayoutService);
    }
}

@Injectable({ providedIn: 'root' })
export class EarlyPayoutSubmitMyBetsService extends EarlyPayoutSubmitService {
    constructor(earlyPayoutService: EarlyPayoutMyBetsService) {
        super(earlyPayoutService);
    }
}

@Injectable({ providedIn: 'root' })
export class EarlyPayoutSubmitEditBetService extends EarlyPayoutSubmitService {
    constructor(earlyPayoutService: EarlyPayoutEditBetService) {
        super(earlyPayoutService);
    }
}
